/* F79 — Reproductor de testimonios en video.
 * Las tarjetas (snippets/testimonio-video-card.liquid) llegan sin <video>: solo portada y
 * botón. El <video> vive en un <template> inerte y se monta aquí, así que la CARGA de la
 * página no pide ni un byte de video.
 *
 * Para que al tocar play arranque ya (Diego, 15-sep: «no son rápidos»), el video se
 * "calienta" antes del clic, en dos escalones:
 *   1. la tarjeta entra en pantalla  → se monta con preload="metadata" (solo el índice)
 *   2. hay intención: cursor encima, toque o foco → preload="auto" (empieza a bajar)
 * Delegado en document: sirve para la ficha y para el home, y sobrevive a que el
 * Personalizador repinte la sección. */
(function () {
  if (window.baTestimoniosVideo) return;
  window.baTestimoniosVideo = true;

  var actual = null;
  var SEL = '[data-tv-card]';

  var salida = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) return;
          var v = e.target.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }, { threshold: 0.25 })
    : null;

  function montar(tarjeta, preload) {
    var video = tarjeta.querySelector('video');
    if (video) {
      if (preload === 'auto' && video.preload !== 'auto') video.preload = 'auto';
      return video;
    }
    var plantilla = tarjeta.querySelector('template[data-tv-video]');
    if (!plantilla) return null;
    tarjeta.appendChild(plantilla.content.cloneNode(true));
    video = tarjeta.querySelector('video');
    if (!video) return null;
    video.preload = preload;
    video.addEventListener('play', function () {
      if (actual && actual !== video && !actual.paused) actual.pause();
      actual = video;
    });
    video.addEventListener('waiting', function () { tarjeta.classList.add('is-cargando'); });
    video.addEventListener('playing', function () { tarjeta.classList.remove('is-cargando'); });
    video.addEventListener('ended', function () { tarjeta.classList.remove('is-playing', 'is-cargando'); });
    video.addEventListener('error', function () { tarjeta.classList.remove('is-cargando'); }, true);
    if (salida) salida.observe(tarjeta);
    return video;
  }

  // Escalón 1: al entrar en pantalla, solo metadatos
  if ('IntersectionObserver' in window) {
    var entrada = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        entrada.unobserve(e.target);
        montar(e.target, 'metadata');
      });
    }, { threshold: 0.6 });
    var vigilar = function () { document.querySelectorAll(SEL).forEach(function (t) { entrada.observe(t); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
    else vigilar();
    document.addEventListener('shopify:section:load', vigilar);
  }

  // Escalón 2: intención (cursor, toque, foco) → empezar a bajar
  function calentar(evento) {
    var tarjeta = evento.target.closest && evento.target.closest(SEL);
    if (tarjeta && !tarjeta.classList.contains('is-playing')) montar(tarjeta, 'auto');
  }
  document.addEventListener('pointerover', calentar, { passive: true });
  document.addEventListener('touchstart', calentar, { passive: true });
  document.addEventListener('focusin', calentar);

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-tv-play]');
    if (!boton) return;
    var tarjeta = boton.closest(SEL);
    var video = tarjeta && montar(tarjeta, 'auto');
    if (!video) return;

    tarjeta.classList.add('is-playing');
    if (video.readyState < 3) tarjeta.classList.add('is-cargando');
    var promesa = video.play();
    if (promesa && promesa.catch) promesa.catch(function () { tarjeta.classList.remove('is-cargando'); });
    video.focus({ preventScroll: true });
  });
})();
